<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-tw">
                <div class="c-td">
                    <div class="typo-label">
                        Data rozpoczęcia / Data zakończenia
                    </div>
                    {{ $moment(data.promo.start_at).format('DD-MM-YYYY') }} /
                    <br class="d-lg-flex d-none"/>
                    {{ $moment(data.promo.end_at).format('DD-MM-YYYY') }}
                </div>
                <div class="c-td">
                    <div class="typo-label">Promocja (ID)</div>
                    <div class="flex-lg-column d-inline-flex">
                        {{ data.promo.name }}
                        <router-link
                            :to="`/promo-details/${data.promo.id}`"
                            class="text-primary text-decoration-none ml-1"
                        >
                            ({{ data.promo.id }})
                        </router-link>
                    </div>
                </div>
                <div class="c-td">
                    <div class="typo-label">Organizator</div>
                    {{ data.promo.company.name }}
                </div>
                <div class="c-td">
                    <span
                        class="status w-100"
                        :class="{
                            'is-success': data.promo.state === 'active',
                            'is-finished': data.promo.state === 'finished',
                            'is-canceled': data.promo.state === 'cancelled'
                        }"
                    >
                        <span v-text="setStatusLabel" />
                    </span>
                </div>
                <div class="c-td">
                    <div class="typo-label">Liczba sprzedanych sztuk</div>
                    {{ data.usages_amount }}
                </div>
                <div class="c-td">
                    <div class="typo-label">Osiągnięty próg</div>
                    {{ achievedStepsAmount }} / {{ data.salesTargetThresholds.length }}
                </div>
                <div class="c-td">
                    <span class="d-none d-xl-inline">
                        {{ data.salesTargetThresholds.length }}
                    </span>
                    <button
                        class="btn btn-auto c-promos-toggle ml-xl-2"
                        data-toggle="collapse"
                        data-target="#reports-table-1"
                        aria-controls="reports-table-1"
                        aria-expanded="false"
                        @click="showThresholds = !showThresholds"
                    >
                        <a-icon icon="Dropdown" />
                        <span class="d-inline d-xl-none">Progi</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-tm collapse" :class="{ show: showThresholds }">
            <h4 class="h5">Progi</h4>
            <div
                v-for="(threshold, idx) in data.salesTargetThresholds"
                class="tr-data__cell"
                :key="`threshold-${idx}`"
            >
                <span class="tr-data__dt" :class="{ 'text-primary': threshold.target <= data.usages_amount }">
                    Próg {{ ++idx }} (nagroda) -
                    {{ threshold.target }} szt.
                    ({{ threshold.prize_amount | currency(data.promo.type) }})
                </span>
                <a-icon
                    v-if="threshold.target <= data.usages_amount"
                    width="1.2rem"
                    class="status-icon-ok ml-2"
                    icon="Ok"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showThresholds: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        statuses() {
            return this.$store.getters.getSaleGoalsStatuses
        },
        setStatusLabel() {
            return this.statuses.find(el => el.value === this.data.promo.state)?.label ||
            this.data.promo.state
        },
        achievedStepsAmount() {
            const { usages_amount, salesTargetThresholds } = this.data
            return usages_amount
                ? salesTargetThresholds.findLastIndex(step => step.target <= usages_amount) + 1
                : 0
        }
    },
    methods: {
        isAchievedStep(value) {
            return value <= this.data.usages_amount
        }
    }
}
</script>
